<template>
  <div class="product-list-wrap">
    <div class="head-operat" v-if="isSearch || total != 0">
      <vh-button
        type="primary"
        size="medium"
        round
        class="head-btn set-upload"
        @click="createProduct"
        v-if="!isInWebinar && hasGoodsEditPermission"
      >
        {{ $t('lang.k_307001') }}
      </vh-button>
      <vh-button
        type="primary"
        size="medium"
        round
        class="head-btn set-upload"
        @click="openMaterial"
        v-if="isInWebinar"
      >
        {{ $t('lang.k_307002') }}
      </vh-button>
      <vh-button
        round
        size="medium"
        type="info"
        plain
        class="head-btn set-upload"
        @click="setStatus()"
        :disabled="selectIds.length <= 0"
        v-if="isInWebinar"
      >
        {{ $t('lang.k_307003') }}
      </vh-button>
      <vh-button
        round
        size="medium"
        type="info"
        plain
        :class="['transparent-btn', { 'no-data': selectIds.length <= 0 }]"
        :disabled="selectIds.length <= 0"
        @click="onDelete('')"
        v-if="hasGoodsEditPermission"
      >
        {{ $t('lang.k_307004') }}
      </vh-button>
      <vh-input
        round
        size="medium"
        @keyup.enter.native="getList('clearPage')"
        clearable
        :maxlength="30"
        @clear="getList('clearPage')"
        style="width: 220px"
        class="head-btn fr search-tag"
        v-model="searchParams.searchName"
        autocomplete="off"
        :placeholder="$t('lang.k_307005')"
      >
        <i class="vh-icon-search vh-input__icon" slot="prefix" @click="getList('clearPage')"></i>
      </vh-input>
    </div>
    <div v-if="!total && !isSearch" class="oh">
      <null-page
        :nullType="'nullData'"
        :text="isInWebinar ? $t('lang.k_307006') : $t('lang.k_307007')"
      >
        <vh-button
          v-if="!isInWebinar"
          size="medium"
          type="primary"
          round
          @click="createProduct"
          v-preventReClick
        >
          {{ $t('lang.k_307001') }}
        </vh-button>
        <vh-button v-else size="medium" type="primary" round @click="openMaterial" v-preventReClick>
          {{ $t('lang.k_307002') }}
        </vh-button>
      </null-page>
    </div>
    <vh-table
      @select-all="onSelect"
      empty-text=""
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      ref="multipleTable"
      :header-cell-style="{ background: '#f7f7f7', color: '#666', height: '56px' }"
      v-if="total > 0 || isSearch"
      @selection-change="onSelect"
    >
      <span slot="empty"></span>
      <vh-table-column type="selection" width="55" align="left" />

      <vh-table-column v-if="isInWebinar" width="80">
        <template slot="header" slot-scope="scope">
          {{ $t('lang.k_307008') }}
          <vh-tooltip effect="dark" placement="top-start" v-tooltipMove>
            <div slot="content">
              {{ $t('lang.k_307009') }}
              <br />
              {{ $t('lang.k_307010') }}
            </div>
            <i class="iconfont-v3 saasicon_help_m icon__max_show"></i>
          </vh-tooltip>
        </template>
        <template slot-scope="scope">
          <vh-input
            v-model.number="scope.row.order_num"
            @focus="onFocus(scope.row)"
            @blur="onBlur(scope.row)"
            @keyup.enter.native="$event => $event.target.blur()"
          ></vh-input>
        </template>
      </vh-table-column>
      <vh-table-column label="ID" prop="goods_id" width="80"></vh-table-column>
      <vh-table-column :label="$t('lang.k_307011')" width="100">
        <template slot-scope="scope">
          <div class="product-cover">
            <img
              :src="scope.row.cover_img"
              alt=""
              v-parseImgOss="{ url: scope.row.cover_img, default: 1 }"
            />
          </div>
        </template>
      </vh-table-column>
      <vh-table-column
        :label="$t('lang.k_307012')"
        prop="name"
        min-width="156"
        show-overflow-tooltip
      ></vh-table-column>
      <vh-table-column :label="$t('lang.k_307013')" prop="price" width="110">
        <template slot-scope="scope">
          <p v-if="scope.row.enable_multi_config == 0">
            {{ scope.row.price ? `￥${scope.row.price}` : `--` }}
          </p>
          <p v-else>
            {{ scope.row.sku[0].price ? `￥${scope.row.sku[0].price}` : `--` }}
          </p>
        </template>
      </vh-table-column>
      <vh-table-column :label="$t('lang.k_307014')" width="110">
        <template slot-scope="scope">
          <p v-if="scope.row.enable_multi_config == 0">
            {{ scope.row.discount_price !== null ? `￥${scope.row.discount_price}` : `--` }}
          </p>
          <p v-else>
            {{ scope.row.sku[0].discount_price ? `￥${scope.row.sku[0].discount_price}` : `--` }}
          </p>
        </template>
      </vh-table-column>
      <vh-table-column :label="$t('lang.k_307015')" width="120">
        <template slot-scope="scope">
          <p>
            {{ scope.row.enable_multi_config == 0 ? $t('lang.k_307016') : $t('lang.k_307017') }}
          </p>
        </template>
      </vh-table-column>

      <vh-table-column :label="$t('lang.k_307018')" width="130">
        <template slot-scope="scope">
          <p class="buy_type">{{ scope.row | buyTypeFilter }}</p>
        </template>
      </vh-table-column>
      <vh-table-column
        v-if="isInWebinar"
        :width="!isBigScreen ? 105 : ''"
        minWidth="105px"
        :label="$t('lang.k_307019')"
      >
        <template slot="header">
          <span class="push-status-header">
            {{ $t('lang.k_307019') }}
            <vh-tooltip effect="dark" placement="right" v-tooltipMove>
              <p slot="content">
                {{ $t('lang.k_307020') }}
                <br />
                {{ $t('lang.k_307021') }}
                <br />
                {{ $t('lang.k_307022') }}
              </p>
              <i class="iconfont-v3 saasicon_help_m"></i>
            </vh-tooltip>
          </span>
        </template>
        <template slot-scope="scope">
          {{ scope.row.status | statusFilter }}
        </template>
      </vh-table-column>
      <vh-table-column v-if="isInWebinar" :label="$t('lang.k_307023')">
        <template slot-scope="scope">
          {{ scope.row.push_status | pushStatusFilter }}
        </template>
      </vh-table-column>
      <vh-table-column :label="$t('lang.k_307024')" prop="name" width="150">
        <template slot-scope="scope">
          <p>
            <vh-tooltip
              effect="dark"
              :content="generateOperator(scope.row)"
              :disabled="generateOperator(scope.row, true).length <= 8"
              placement="top"
            >
              <span>
                {{ generateOperator(scope.row, true) }}
              </span>
            </vh-tooltip>
          </p>
          <p>
            {{ scope.row.updated_at }}
          </p>
        </template>
      </vh-table-column>
      <vh-table-column
        v-if="!(!isInWebinar && !hasGoodsEditPermission)"
        :label="$t('lang.k_307025')"
        align="left"
        width="150"
        fixed="right"
      >
        <template slot-scope="scope">
          <vh-button
            v-if="!isInWebinar"
            v-preventReClick
            class="btns"
            type="text"
            @click="onCopy(scope.row)"
          >
            {{ $t('lang.k_307026') }}
          </vh-button>
          <vh-button
            v-if="!isInWebinar"
            v-preventReClick
            class="btns"
            type="text"
            @click="onEdit(scope.row)"
          >
            {{ $t('lang.k_307027') }}
          </vh-button>
          <vh-button v-preventReClick class="btns" type="text" @click="onDelete(scope.row)">
            {{ $t('lang.k_307028') }}
          </vh-button>
          <vh-button
            v-if="isInWebinar"
            v-preventReClick
            class="btns"
            type="text"
            @click="setStatus(scope.row)"
          >
            {{ $t('lang.k_307019') }}
          </vh-button>
        </template>
      </vh-table-column>
    </vh-table>
    <SPagination
      :total="total"
      :page-size="searchParams.page_size"
      :currentPage="searchParams.page"
      @current-change="currentChange"
      @size-change="sizeChange"
    ></SPagination>
    <null-page
      :text="$t('lang.k_307029')"
      nullType="search"
      v-if="total === 0 && isSearch"
    ></null-page>
    <ProductMaterial
      v-if="isInWebinar"
      @success="getList('clearPage')"
      ref="materialRef"
    ></ProductMaterial>
    <product-status-set @success="getList" ref="statusSetRef"></product-status-set>
  </div>
</template>

<script>
  import NullPage from '../../PlatformModule/Error/nullPage.vue';
  import { overHidden } from '@/utils/utils.js';
  import ProductMaterial from './material.vue';
  import ProductStatusSet from './statusSet.vue';
  import { isEmbed } from '@/utils/utils';
  import {
    getAdminProductsList,
    getAdminWebinarProductsList,
    deleteAdminProduct,
    deleteWebinarProduct,
    copyAdminProduct,
    setWebinarProductOrder
  } from '@vhcl/product';
  import i18n from '@/common/i18n';

  export const buyTypeMap = {
    1: i18n.t('lang.k_307030'),
    2: i18n.t('lang.k_307031'),
    3: i18n.t('lang.k_307032'),
    4: i18n.t('lang.k_307033')
  };
  export const pushStatusMap = {
    0: i18n.t('lang.k_307034'),
    1: i18n.t('lang.k_307035'),
    2: i18n.t('lang.k_307036')
  };
  export const statusMap = {
    0: i18n.t('lang.k_307037'),
    1: i18n.t('lang.k_307038'),
    2: i18n.t('lang.k_307039')
  };

  export default {
    name: 'ProductList',
    data() {
      return {
        isSearch: false,
        isBigScreen: true,
        selectIds: [], // 批量删除列表
        total: 0, // 列表总数
        searchParams: {
          searchName: '', // 搜索商品名称
          // 分页数据
          page_size: 10,
          page: 1
        },
        tableData: [] // 列表数据
      };
    },
    props: {
      isInWebinar: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    components: {
      NullPage,
      ProductMaterial,
      ProductStatusSet
    },
    computed: {
      // 是否有商品编辑权限
      hasGoodsEditPermission() {
        // 有权限：1【默认，省缺值】 无权限：2
        return this.$store.state?.permissionValue?.['goods_edit_permission'] == 1;
      }
    },
    mounted() {
      this.getList('clearPage');
      window.addEventListener('resize', this.resize);
      this.resize();
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);
    },
    filters: {
      buyTypeFilter(val) {
        if (val.enable_multi_config == 0) {
          return buyTypeMap[val.buy_type];
        } else {
          return val.sku.map(el => buyTypeMap[el.buy_type]).join('\n');
        }
      },
      pushStatusFilter(val) {
        return pushStatusMap[val];
      },
      statusFilter(val) {
        return statusMap[val];
      },
      overHidden
    },
    methods: {
      generateOperator(row, hide) {
        // NOTE: 这里有通过中文判断，不翻译
        const str =
          row.operator_role === 'Host' || row.operator_role === '主持人'
            ? row.operator
            : `${row.operator_role}-${row.operator}`;
        if (hide) {
          return overHidden(str, 8);
        }
        return str;
      },
      resize() {
        const clientWidth = document.body.clientWidth;
        if (clientWidth < 1920) {
          this.isBigScreen = false;
        } else {
          this.isBigScreen = true;
        }
      },
      openMaterial() {
        this.$refs.materialRef.open();
      },
      createProduct() {
        this.$router.push(`${isEmbed() ? '/embed' : ''}/interactive/addProduct`);
      },
      getList(type) {
        if (type == 'clearPage') {
          this.searchParams.page = 1;
        }
        this.isSearch = this.searchParams.searchName ? true : false;
        this.requestList().then(res => {
          if (res.code == 200) {
            this.total = res.data.total;
            this.tableData = res.data.list;
          }
        });
      },
      requestList() {
        const commonParams = {
          keyword: this.searchParams.searchName,
          pos: (this.searchParams.page - 1) * this.searchParams.page_size,
          limit: this.searchParams.page_size
        };
        if (this.isInWebinar) {
          return getAdminWebinarProductsList({
            ...commonParams,
            webinar_id: this.$route.params.str
          });
        }
        return getAdminProductsList(commonParams);
      },
      onSelect(val) {
        console.log(val);
        if (val?.length) {
          this.selectIds = val.map(item =>
            this.isInWebinar ? item.webinar_goods_id : item.goods_id
          );
        } else {
          this.selectIds = [];
        }
      },
      onFocus(row) {
        // 聚焦暂存，失焦做对比
        this._order_num = row.order_num;
      },
      // 排序
      onBlur(row) {
        if (
          row.order_num === '' ||
          row.order_num > 9999 ||
          row.order_num < 0 ||
          row.order_num == this._order_num ||
          (row.order_num > 0 && row.order_num < 1) ||
          typeof row.order_num != 'number'
        ) {
          row.order_num = this._order_num;
          return false;
        }

        setWebinarProductOrder({
          webinar_goods_id: row.webinar_goods_id,
          order_num: row.order_num
        })
          .then(res => {
            if (res.code == 200) {
              this.$vhMessage.success(this.$t('lang.k_307041'));
              this.getList();
            } else {
              this.$vhMessage.error(this.$t('lang.k_307042'));
            }
          })
          .catch(() => {
            this.$vhMessage.error(this.$t('lang.k_307042'));
          });
      },
      onCopy(row) {
        copyAdminProduct({
          goods_id: row.goods_id
        })
          .then(res => {
            if (res.code == 200) {
              this.$vhMessage.success(this.$t('lang.k_307043'));
              this.getList();
            } else {
              this.$vhMessage.error(this.$t('lang.k_307044'));
            }
          })
          .catch(() => {
            this.$vhMessage.error(this.$t('lang.k_307044'));
          });
      },
      onEdit(row) {
        this.$router.push(`${isEmbed() ? '/embed' : ''}/interactive/addProduct/${row.goods_id}`);
      },
      onDelete(row) {
        this.$vhConfirm(this.$t('lang.k_307045'), this.$t('lang.k_307046'), {
          confirmButtonText: this.$t('lang.k_307047'),
          cancelButtonText: this.$t('lang.k_307048'),
          roundButton: true,
          customClass: 'zdy-message-box',
          lockScroll: false,

          cancelButtonClass: 'zdy-confirm-cancel'
        })
          .then(() => {
            this.requestDeleteProduct(row)
              .then(res => {
                if (res.code == 200) {
                  this.$vhMessage.success(this.$t('lang.k_307049'));
                  this.getList('clearPage');
                  this.selectIds = [];
                } else {
                  this.$vhMessage.error(this.$t('lang.k_307050'));
                }
              })
              .catch(() => {
                this.$vhMessage.error(this.$t('lang.k_307050'));
              });
          })
          .catch(e => {
            this.$vhMessage({
              message: `${this.$t('lang.k_307051')}`,
              showClose: true,
              type: 'info',
              customClass: 'zdy-info-box'
            });
          });
      },
      requestDeleteProduct(row) {
        if (this.isInWebinar) {
          return deleteWebinarProduct({
            webinar_goods_ids: row ? [row.webinar_goods_id] : this.selectIds
          });
        }
        return deleteAdminProduct({
          goods_ids: row ? [row.goods_id] : this.selectIds
        });
      },
      setStatus(row) {
        this.$refs.statusSetRef.open(row || this.selectIds);
      },
      currentChange(val) {
        this.searchParams.page = val;
        this.getList();
      },
      sizeChange(val) {
        this.searchParams.page = 1;
        this.searchParams.page_size = val;
        this.getList();
      }
    }
  };
</script>

<style lang="less" scoped>
  .product-list-wrap {
    min-height: 572px;
    .head-operat {
      overflow: hidden;
      padding-bottom: 24px;
    }
    .oh {
      overflow: hidden;
    }
    .product-cover {
      width: 70px;
      height: 70px;
      overflow: hidden;
      border-radius: 4px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .push-status-header {
      display: inline-block;
      min-width: 80px;
      font-weight: inherit;
      white-space: nowrap;
      i {
        cursor: pointer;
      }
    }
    .buy_type {
      white-space: pre-line;
    }
  }
</style>
